exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-loading {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: opacity 1.5s ease-in-out infinite;\n}\n.content-loading img {\n  width: 104px;\n  height: 24px;\n  margin-right: 300px;\n}\n@keyframes opacity {\n  0% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.3;\n  }\n}\n", ""]);

// exports
